import { h, render } from 'preact';
import Widget from './components/widget';
import store from './reducers'
import * as actions from './actions'
import {
    OrganizationActions, 
    PatientActions, 
    SessionActions, 
    ConfigActions, 
    AccountActions, 
    PageActions, 
    FilterActions,
    LoadingActions
} from './actions'
import {helpers} from './lib'
import dayjs from './lib/helpers/dayjs';
import events from 'actions/events'
import eventFlows from 'eventFlows'
import { uuid } from 'lib/helpers';
let gravityURL = false;
module.exports = {
    init: (options = {})=>{
        options.widgetID = helpers.uuid()

        actions.TrackingActions.start()
        let _options = {
            organizationID: '',
            NILToken: '',
            version: '',
            type: '',
            date: '',
            magicLink: false,
            appointmentTypeID: '',
            cost: options.cost,
            resetPassword: false,
            demoMode: false,
            prefillEmail: '',
            prefillMobilePhone: '',
            skip: [],
        }

        



        for(let key of Object.keys(options)){
            for(let _key of Object.keys(_options)){
                if(options[key] && _key.toLowerCase() == key.toLowerCase()){
                    _options[_key] = options[key]
                }
            }
        }

        let variableWhiteList = ['reason']
        for(let [key, value] of Object.entries(options)){
            let splitKey = key.split('.')
            if(variableWhiteList.includes(splitKey[0]) && splitKey.length == 2){
                if(value === 'true'){
                    value = true
                } else if (value === 'false'){
                    value = false
                }
                
                _options[`${splitKey[0]}`] = {
                    ...(_options[`${splitKey[0]}`] || {}),
                    [`${splitKey[1]}`]: value
                }
            }
        }
        if(_options.skip && _options.skip.includes("appointment.reason")){
            _options.reason = {
                ...Object(_options.reason),
                hide: true
            };
        }

        ConfigActions.set(_options)


        store.subscribe(()=>{
            
            const organization = (
                store.getState() || {}
            ).organization
            
            if(organization.id){                
                let _gravityURL
                if(_.get(organization,'gravity.staging')){
                    _gravityURL = 'https://assets.emergepay-sandbox.chargeitpro.com'
                }else{
                    _gravityURL = 'https://assets.emergepay.chargeitpro.com'
                }
    
                if(_gravityURL !== gravityURL){
                    gravityURL = _gravityURL
                    const gravity = document.createElement('script');
                    gravity.src = gravityURL+'/cip-hosted-fields.js';
                    gravity.type = 'application/javascript';
        
                    
                    document.body.appendChild(gravity);
                }
            }
        })

        return {
            root: null,
            store,
            actions,
            options: _options,
            events,
            render: function(target){
                if(target) this.target = target
                this.target.innerHTML = ''
                
                eventFlows[this.options.type || 'defaultFlows']()

                if(this.options.organizationID){
                    LoadingActions.append({init: true})

                    OrganizationActions.findByID(this.options.organizationID).then(()=>{
                        let filterDate = dayjs()

                        FilterActions.set({
                            ...store.getState().filters,
                            startDate: filterDate.format()
                        })

                        if(Object(store.getState().organization.settings).refreshSync){
                            OrganizationActions.refreshSync()
                        }
                    
                        if(store.getState().page == 'receipt'){
                            PageActions.reset()
                        }

                        if((store.getState().organization.settings || {}).genericPatients){
                            ConfigActions.append({
                                genericPatients: true
                            })
                        }
                        
                        if(!this.options.NILToken && _.get(store.getState(), 'session.accountID')){
                            events.trigger('Account.accountDidSubmit', store.getState().session.account)
                            PatientActions.fetch({organizationID: this.options.organizationID}).then(()=>{
                                if((store.getState().organization.settings || {}).genericPatients && store.getState().session.accountID){
                                    let account = store.getState().session.account
                                    let accountMatch = false
                                    for(let patient of Object.values(store.getState().patients)){
                                        if(patient.firstName && patient.firstName.toLowerCase() == account.firstName.toLowerCase() && 
                                            patient.lastName && patient.lastName.toLowerCase() == account.lastName.toLowerCase()
                                        ){
                                            accountMatch = true
                                        }
                                    }
                                    if(!accountMatch){
                                        let patient = {
                                            firstName: account.firstName,
                                            lastName: account.lastName,
                                            id: `newPatient-${account.firstName.replace(/ /g, '-')}-${account.lastName.replace(/ /g, '-')}`,
                                        }
                                
                                        PatientActions.append(patient)
                                    }
                                }
                            })


                            PageActions.navToFilters()
                            LoadingActions.append({init: false})
                        } else {
                            if(this.options.NILToken){
                                SessionActions.set({
                                    accessToken: this.options.NILToken,
                                    authenticating: true
                                })

                                AccountActions.fetchSession().then((res)=>{
                                    if(res && store.getState().config.resetPassword){
                                        SessionActions.set({
                                            ...store.getState().session
                                        })

                                        PageActions.navToPasswordReset()
                                    } else {
                                        SessionActions.set({})
                                    }

                                    LoadingActions.append({init: false})
                                    events.trigger('Organization.dataFetched')
                                })
                            } else {
                                if((store.getState().session || {}).resetPassword){
                                    SessionActions.set({})
                                }

                                events.trigger('Organization.dataFetched')
                                LoadingActions.append({init: false})
                            }
                        }
                    });
                }

                this.root = render(<Widget />, this.target, this.target);
                return this;
            }
        }
    }
}

const script = document.createElement('script');
let baseURL = '';
let urlParams = window.location.href.split("?")[1]
let params = {}
if(urlParams){
    params = urlParams.split('&').reduce((acc,item)=>{
        acc[item.split('=')[0]] = item.split('=')[1]
        return acc
    },{})
}
if (params.version){
    baseURL = `https://${params.version}.appspot.com`
} else if(window.location.host.includes('localhost')){
    baseURL = 'http://localhost:4000'
} else {
    baseURL= 'https://shark.nextinline.io'
}
script.src = baseURL+'/js/repeating?version=' + (new Date()).getTime();
script.type = 'application/javascript';

document.body.appendChild(script);



// WEBPACK FOOTER //
// ./widget.js